document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(accordion => {
    const button = accordion.querySelector('[data-accordion-button]');
    const panel = accordion.querySelector('[data-accordion-panel]');

    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';

      button.setAttribute('aria-expanded', !isOpen);
      button.classList.toggle('is-open');

      panel.classList.toggle('is-open');

      if (isOpen) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
    });
  });
}); 